import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function Curriculum() {
  const [pillars, setPillars] = useState([]);

  useEffect(() => {
    api.get("/course/overview").then((r) => setPillars(r.data.pillars)).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 py-20">
      <div className="text-xs uppercase tracking-[0.25em] text-[#A36B5E]">The Curriculum</div>
      <h1 className="font-display text-5xl text-[#2D2A26] mt-3 tracking-tight">
        Nine lessons. Three Scriptures. One transformation.
      </h1>
      <p className="mt-6 text-lg text-[#5C5852] max-w-2xl leading-relaxed">
        Each pillar centers on a single passage. Each lesson includes a teaching, a reflection prompt,
        a journaling space, and <em>The Inner Room</em> — a quiet companion to think it through.
      </p>

      <div className="mt-16 space-y-16">
        {pillars.map((p, idx) => (
          <div key={p.id} data-testid={`curriculum-pillar-${p.id}`}>
            <div className="flex items-baseline gap-4 mb-4">
              <div className="font-display text-6xl text-[#C49A7E]/50 italic">0{idx + 1}</div>
              <div>
                <div className="text-xs uppercase tracking-widest text-[#8A857D]">{p.scripture_ref}</div>
                <h2 className="font-display text-3xl sm:text-4xl text-[#2D2A26] tracking-tight">{p.title}</h2>
              </div>
            </div>
            <blockquote className="border-l-2 border-[#A36B5E] pl-6 italic text-[#5C5852] my-6 max-w-3xl leading-relaxed">
              "{p.scripture_text}"
            </blockquote>
            <p className="text-[#5C5852] max-w-3xl mb-6">{p.summary}</p>
            <div className="grid sm:grid-cols-3 gap-4">
              {p.lessons.map((l, i) => (
                <div key={l.id} className="bg-white border border-[#EAE5D9] rounded-2xl p-6">
                  <div className="text-xs uppercase tracking-widest text-[#A36B5E]">Lesson {i + 1}</div>
                  <h3 className="font-display text-xl text-[#2D2A26] mt-2">{l.title}</h3>
                  <div className="text-xs text-[#8A857D] mt-3">{l.duration_min} min</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-20 text-center">
        <Link
          to="/register"
          data-testid="curriculum-cta"
          className="btn-primary rounded-full px-8 py-4 inline-flex items-center gap-2 font-medium"
        >
          Start with the free preview
        </Link>
      </div>
    </div>
  );
}
